import { useContext } from 'react';
import { Person } from 'react-bootstrap-icons';
import Access from '../../../../libs/api/services/Access';
import Authentication from '../../../../libs/api/services/Authentication';
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider';
// import FlattenedHash from '../../../../libs/templating/FlattenedHash';

export default function DashboardWidgetProfile() {

  // return <></>
  return (
    <div className={`col-lg-4 col-md-12 dashboard-card`} style={{
      maxHeight: 'calc(50% - 0.5rem)',
      // height: 'calc(50% - 0.5rem)'

    }
    }>
      <div className='text-center bg-secondary-container p-3 rounded h-100 d-flex flex-column'>
        <div className='flex-shrink-1'>
          <h3><Person className='me-2' />Profile</h3>
        </div>
        {
          <>
            <div style={{ overflowY: 'auto', overflowX: 'hidden' }} className='flex-grow-1 d-flex flex-column justify-content-start align-items-start '>

              <div className='d-flex w-100 align-items-center justify-content-center '>
                <Person />
                <div className='flex-grow-1'>
                  {Authentication.UserName() && JSON.parse(Authentication.UserName())}
                </div>
                <div>
                  <button className='btn' onClick={() => window.location.href = '/Dashboard/profile'}>Manage my profile</button>
                </div>
              </div>
            </div>
          </>
        }

      </div>
    </div>
  )
}

export const ConsentModal = ({ close, request, onClosed }) => {
  const { showError } = useContext(CommonFunctionsContext)
  const handleApprove = () => {

    close(() => {
      Access.ApproveConsentRequest(request.rule.id, request.id).catch(showError)
        .then(() => onClosed())
    })
  }
  const handleDecline = () => {

    close(() => {
      Access.DeclineConsentRequest(request.rule.id, request.id).catch(showError)
        .then(() => onClosed())
    })
  }
  return <div className='d-flex flex-column flex-grow-1 p-3'>
    <div className='flex-grow-1'>
      <div className='text-center py-3'>
        {request.shareWith && `${request.shareWith.firstName} ${request.shareWith.lastName} would like the following access ${request.shareFor.id === parseInt(Authentication.UserId()) ? 'to your profile' : `for ${request.shareFor.firstName} ${request.shareFor.lastName}`} `}
      </div>
      <div className='shadow p-3 rounded flex-grow-1'>
        {request.rule.accessRuleResources.map(resource =>
          <div className='d-flex'>
            <div className='flex-grow-1' key={resource.id}>{resource.accessType} {resource.human}</div>
          </div>
        )}
      </div>
    </div>
    <div className='text-center'>
      <button onClick={handleDecline} className='btn bg-primary-container'>Decline</button>
      <button onClick={handleApprove} className='btn bg-primary-container'>Approve</button>
    </div>
  </div>
}